// extracted by mini-css-extract-plugin
export default {"payPeriod-header":"Header_payPeriod-header__3tRHY","payPeriod-header-item":"Header_payPeriod-header-item__I8lhk"};